import { render } from "./TemplateTap.vue?vue&type=template&id=722a1168"
import script from "./TemplateTap.vue?vue&type=script&lang=js"
export * from "./TemplateTap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__